import { PropsWithChildren } from "react";
import { buttonIconVariants } from "./styles.css";
import classNames from "classnames";

export const ButtonIcon = ({
  children,
  onClick,
  primary,
  className,
  style,
  disabled = false,
}: PropsWithChildren<
  {
    onClick?: () => void;
    primary?: boolean;
    disabled?: boolean;
  } & StyledProps
>) => {
  return (
    <button
      className={classNames(
        primary ? buttonIconVariants.primary : buttonIconVariants.default,
        className
      )}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
